import React, { useState, useEffect, useRef } from 'react'
import { navigate } from 'gatsby'
import { BlogSearchIndex, BlogButton, Image, PostGrid } from 'newComponents'
import { useDebounce } from 'hooks'
import searchIcon from '../../../images/blog/search.svg'
import cross from '../../../images/blog/black_cross.svg'
import './styles.scss'

const SearchBar = ({ active, closeSearch, blogPosts, blogIndex }) => {
  const [value, setValue] = useState('')
  const [searchResults, setSearchResults] = useState([])

  const debouncedSearchTerm = useDebounce(value, 500)

  const searchInput = useRef(null)

  useEffect(() => {
    if (active) {
      searchInput.current.focus()
    } else {
      setValue('')
    }
  }, [active])

  const handleChange = (event) => {
    const query = event.target.value
    setValue(query)
  }

  useEffect(() => {
    if (debouncedSearchTerm && debouncedSearchTerm.length > 2 && blogIndex) {
      const search = blogIndex.search(`${value}*`).map((post) => post)
      const matchingPosts = search.map((searchResult) => blogPosts.nodes.find((post) => post.uid === searchResult.ref))
      const top4MatchingPosts = matchingPosts ? [...matchingPosts].slice(0, 6) : []
      setSearchResults(top4MatchingPosts)
    }

    if (!debouncedSearchTerm || debouncedSearchTerm.length <= 2) {
      setSearchResults([])
    }
  }, [debouncedSearchTerm, blogIndex])

  const handleSearch = (event) => {
    event.preventDefault()
    navigate(`/search?q=${value}`)
  }

  return (
    <>
      <div className="blog-search-bar">
        <div className="blog-search-bar-container">
          <Image className="blog-search-bar-icon search" image={searchIcon} />
          <form onSubmit={handleSearch} className="blog-search-bar-form">
            <input
              id="search-input"
              type="search"
              value={value}
              onChange={handleChange}
              placeholder="Search"
              ref={searchInput}
            />
          </form>
          <button className="blog-search-bar-button" type="button" onClick={closeSearch}>
            <Image className="blog-search-bar-icon cross" image={cross} />
          </button>
        </div>
        {searchResults && searchResults.length > 0 && (
          <div className="blog-search-bar-results">
            <PostGrid posts={searchResults.slice(0, 3)} className="suggested-variant" />
            {searchResults.length === 6 && (
              <BlogButton
                to={`/search?q=${value}`}
                ignoreQuery
                onClick={() => closeSearch()}
                removeBlogPath
                className="post-grid-button"
              >
                See all results
              </BlogButton>
            )}
          </div>
        )}
      </div>
    </>
  )
}

export default BlogSearchIndex(SearchBar)
